<template>
  <div class="main print-no-padding accountDetail">
    <h2 class="is-print-hide title-area">
      <div class="title">
        <span class="main-title">账户详情</span>
      </div>
    </h2>
    <el-card class="info-card">
      <span class="label-amount">智云快药余额(元)</span>
      <div style="display: flex; justify-content: space-between; align-items: center">
        <span class="amount">￥{{ detail.accountAmount | fen2Yuan }}</span>
        <el-button type="primary" @click="handleToPay">充值</el-button>
      </div>
    </el-card>
    <el-card>
      <waterBillSearchBar :search-params="searchParams" @change="change" @search="search" />
      <waterBillTable
        :page-no="searchParams.pageNo"
        :page-size="searchParams.pageSize"
        :data="data"
        :total="total"
        @detail="handleViewDetail"
        @handle-pageNo="handlePageNo"
        @handle-pageSize="handlePageSize"
      />
    </el-card>
    <prepayDrawer :visible.sync="payDrawerVisible" :dataList="[detail]" @paySuccess="handlePaySuccess" />
    <waterBillDrawer :visible.sync="waterBillDrawerVisible" :flowId="curRow.flowId" :operateType="curRow.operateType" />
  </div>
</template>

<script>
import Fetch from '@/api';
import waterBillSearchBar from './components/waterBillSearchBar';
import waterBillTable from './components/waterBillTable';
import prepayDrawer from './components/prepayDrawer';
import waterBillDrawer from './components/waterBillDrawer';

export default {
  name: 'accountManage',
  components: {
    waterBillSearchBar,
    waterBillTable,
    prepayDrawer,
    waterBillDrawer
  },
  data() {
    return {
      searchParams: {
        pageNo: 1,
        pageSize: 10,
        accountId: this.$route.query.accountId,
        operateType: null,
        orderSn: '',
        createTime: []
      },
      data: [],
      total: 0,
      selections: [],
      payDrawerVisible: false,
      waterBillDrawerVisible: false,
      curRow: {},
      detail: {}
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    change(key, val) {
      this.searchParams[key] = val;
      if (key === 'createTime') {
        this.searchParams.createTimeStart = (val || [])[0];
        this.searchParams.createTimeEnd = (val || [])[1];
      }
    },
    fetchFlowList(params) {
      return Fetch.getMerchantAccountFlowList(params).then(({ data, pageNo, pageSize, totalCount }) => {
        this.data = data;
        this.total = totalCount;
        this.searchParams.pageNo = pageNo;
        this.searchParams.pageSize = pageSize;
      });
    },
    fetchAccountDetail(accountId) {
      return Fetch.getMerchantAccountList({ accountId, pageNo: 1, pageSize: 1 }).then(({ data }) => {
        console.log(data);
        this.detail = data[0] || {};
      });
    },
    init() {
      this.fetchAccountDetail(this.$route.query.accountId);
      this.fetchFlowList(this.searchParams);
    },
    search() {
      const { accountId, operateType, orderSn, createTimeStart, createTimeEnd } = this.searchParams;
      return this.fetchFlowList({
        accountId,
        operateType,
        orderSn,
        createTimeStart,
        createTimeEnd,
        pageNo: 1,
        pageSize: 10
      });
    },
    handlePageNo(pageNo) {
      const { accountId, operateType, orderSn, createTimeStart, createTimeEnd, pageSize } = this.searchParams;
      return this.fetchFlowList({ accountId, operateType, orderSn, createTimeStart, createTimeEnd, pageNo, pageSize });
    },
    handlePageSize(pageSize) {
      const { accountId, operateType, orderSn, createTimeStart, createTimeEnd, pageNo } = this.searchParams;
      return this.fetchFlowList({ accountId, operateType, orderSn, createTimeStart, createTimeEnd, pageNo, pageSize });
    },
    handleToPay() {
      //  window.open('https://static.91jkys.com/kaer/zhiyunkuaiyao/index.html#/', '_blank');

      if (this.detail.merchantStatus == 1) {
        this.$message.error('药店被禁用');
        return;
      }
      this.payDrawerVisible = true;
    },
    handleViewDetail(row) {
      this.curRow = row;
      this.waterBillDrawerVisible = true;
    },
    handlePaySuccess() {
      this.init();
    }
  }
};
</script>

<style lang="scss" scoped>
.accountDetail {
  .label-amount {
    font-size: 16px;
    color: #242424;
    font-weight: 600;
  }
  .amount {
    font-size: 24px;
    color: #242424;
    font-weight: 600;
    margin-top: 20px;
  }
  /deep/ .el-card__body {
    padding: 12px;
  }
  .info-card {
    margin-bottom: 8px;
  }
}
</style>
